import React from 'react';
import MessageUI from '../../../widgets/output/MessageUI';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';

const AddPhoneModalUI = ({ 
  context, 
  errorList, 
  successMsg, 
  setErrorList,
  onSubmit, 
  onCancelClick, 
  createMode, 
  submitted,
  phone,
  onPhoneChange,
  phoneError,
  setphoneError
}) => {
  return (
    <ModalFormUI
      context={context}
      titleLabel="Add WhatsApp Number"
      buttonLabel={submitted ? "Adding..." : "Add Phone"}
      cancelLabel="Cancel"
      
      isOpen={createMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <InputTextSF 
        type="text"
        name="phone"
        label="Phone Number"
        maxLength={15}
        required={true}
        value={phone} 
        onChange={onPhoneChange}
        error={phoneError} 
        setError={setphoneError}
      />
    </ModalFormUI>
  );
};

export default AddPhoneModalUI;